import { render, staticRenderFns } from "./FactFindIncomes.vue?vue&type=template&id=4435baf8&"
import script from "./FactFindIncomes.vue?vue&type=script&lang=ts&"
export * from "./FactFindIncomes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports